import { useInfiniteQuery } from '@tanstack/react-query'
import { InView } from 'react-intersection-observer'
import useAxios from './useAxios'

const useApiGetWithInfiniteScroll = (
    url,
    queryString,
    enabled = true,
    defaultTake = 16,
) => {
    const callApi = useAxios()

    const {
        data,
        isInitialLoading,
        isIdle,
        isFetchingNextPage,
        fetchNextPage,
        hasNextPage,
        error,
        refetch,
    } = useInfiniteQuery(
        [url, queryString],
        async ({ pageParam = 1 }) => {
            const skip = (pageParam - 1) * defaultTake
            const skipTakeQueryParam = `skip=${skip}&take=${defaultTake}`
            const fullUrl =
                url +
                (queryString
                    ? `?${skipTakeQueryParam}&${queryString}`
                    : `?${skipTakeQueryParam}`)

            return await callApi({
                url: fullUrl,
            })
        },
        {
            getNextPageParam: (lastPage) => {
                if (lastPage.totalCount > lastPage.skip + lastPage.take) {
                    const nextPage = lastPage.skip / defaultTake + 2
                    return nextPage
                } else {
                    return undefined
                }
            },
            enabled: !!enabled,
        },
    )

    let list = data ? [] : undefined
    if (data) {
        for (let i = 0; i < data.pages.length; i++) {
            list = list.concat(data.pages[i].data)
        }
    }

    const infiniteScrollObervableDiv = (
        <InView
            as="div"
            threshold={1}
            onChange={(inView) => {
                if (inView && !isFetchingNextPage && hasNextPage) {
                    fetchNextPage()
                }
            }}
        />
    )

    return {
        totalCount: data
            ? data.pages[data.pages.length - 1].totalCount
            : undefined,
        loading: isInitialLoading || isIdle,
        list,
        rest: data ? data.pages[data.pages.length - 1] : undefined,
        error,
        loadingMore: isFetchingNextPage,
        infiniteScrollObervableDiv,
        revalidate: refetch,
    }
}

export default useApiGetWithInfiniteScroll
